import React from 'react'
import 'raf/polyfill'
import 'babel-polyfill'
import axios from 'axios'
import { withRouter } from 'react-router-dom'
import './index.css'
import { connect } from 'react-redux'
import {getVipUser} from '../../redux/user.redux'
import {getUnReadNum} from '../../redux/chatuser.redux.js'
import {userList} from '../../redux/chatuser.redux.js'
@withRouter

@connect(
  state=>state.chatuser,
  {getUnReadNum,userList}
)
class LoginPage extends React.Component{
	constructor(props){
		super(props)
		this.state={
			ifref:'',
			oHref:'',
			iSpan:0,
			iH6:'盛趣游戏用户登录',
			iH7:'龙之谷与永恒之塔的WeGame账号信息独立不互通'
		}

		this.oHref = this.props.location.query?this.props.location.query:'/index'
		
		
	}
	componentDidMount(){
		
		//if(this.props.showLogin){
		//	window.location.href='/'
			//return
		//}
		
		this.loginFn('getLoginURL')

		
	}
	componentWillReceiveProps(nextProps){

		if(this.props.userlist!=nextProps.userlist){
					//console.log(nextProps.userlist)
			if(nextProps.userlist.code==-1){
				
			}else{
				this.props.history.push('/index')
			}
		}
	}
	handleSpan(i){
		this.setState({
			iSpan:i
		})
		if(i===0){
			this.loginFn('getLoginURL')
			this.setState({
				iH6:'盛趣游戏用户登录'
			})
		}else if(i===1){
			//this.loginFn('getLoginDNURL')
			this.setState({
				iH6:'WeGame、Steam用户登录'
			})
		}else if(i===2){
			//this.loginFn('getLoginaionURL')
			this.setState({
				iH6:'WeGame用户登录'
			})
		}
	}
	loginFn(isrc,iplat){
		
		axios.get('/fapi/'+isrc+'?plat='+iplat+'&&redirect_url='+encodeURIComponent(encodeURIComponent('/')))
	      .then(res=>{
	       	if(res.data.return_code==0){
	       						
				if(this.state.iSpan==0){
					this.setState({
						ifref:res.data.redirect_url
					})
				}else{
					window.location.href = res.data.redirect_url
				}
				
		      
	       	}
	     
	    })
	}
	render(){
		
		//this.props.userlist.code?null:this.props.history.push('/index')
		return(
			<div className="login-page-wrap">
				<div className="login-page-head">
					<i></i>
					<span>登录</span>
				</div>
				<div className="login-page-con">
					<nav>
						<span 
							className={this.state.iSpan===0?'active':''} 
							onClick={()=>this.handleSpan(0)}
						></span>
						<span 
							className={this.state.iSpan===1?'active':''} 
							onClick={()=>this.handleSpan(1)}
						></span>
						
						{false&&<span

							className={this.state.iSpan===2?'active':''} 	
							onClick={()=>this.handleSpan(2)}
						></span>}
					</nav>
					<h6>{this.state.iH6}</h6>
					<span className="expl">{this.state.iSpan===0?'':this.state.iH7}</span>
					<div className="iframeBox">
						{
							this.state.iSpan===0&&<div className="iframeBox1">
								<iframe width="500" height="450"  
									src={this.state.ifref} 
							
									frameBorder="0">
								</iframe>
							</div>	
						}
						{
							this.state.iSpan===1&&<div className="dn-login">
								<span 
									className="wegame-logo"
									onClick={()=>this.loginFn('getLoginDNURL','wegame')}
								>
								</span>
								<span 
									className="steam-logo"
									onClick={()=>this.loginFn('getLoginDNSteamURL','')}
								></span>
								<span 
									className="feihuo-logo"
									onClick={()=>this.loginFn('getLoginDNURL','feihuo')}
								></span>
							</div>
						}
						{
							this.state.iSpan===2&&<div className="aion-login">
								<span 
									className="wegame-logo wegame-logo-2"
									onClick={()=>this.loginFn('getLoginaionURL','weGame')}
								></span>
							
							</div>
						}
						
						

					</div>
				
				</div>

			</div>
		)
	}
}
export default LoginPage


// WEBPACK FOOTER //
// ./src/container/login-page/index.js